/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_EditedInputs */

const vi_einvoice_draft_edited = /** @type {(inputs: Einvoice_Draft_EditedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nháp đang có chỉnh sửa riêng trên hóa đơn (ngày, tên hàng, chiết khấu, VAT hoặc dòng đã xóa). Muốn bỏ các chỉnh sửa này và lấy lại đủ dòng hàng của đơn thì bấm Tạo lại từ đơn hàng; thông tin người mua vẫn giữ nguyên.`)
};

/**

* @param {Einvoice_Draft_EditedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_edited = /** @type {((inputs?: Einvoice_Draft_EditedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_EditedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_edited(inputs)
});